import { render, staticRenderFns } from "./ChangeTypeReferral.vue?vue&type=template&id=04e1a6d4&scoped=true&"
import script from "./ChangeTypeReferral.vue?vue&type=script&lang=ts&"
export * from "./ChangeTypeReferral.vue?vue&type=script&lang=ts&"
import style0 from "./ChangeTypeReferral.vue?vue&type=style&index=0&id=04e1a6d4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e1a6d4",
  null
  
)

export default component.exports